import React, { useState } from 'react';
import Navigation from '../components/Navigation';
import { HiMenu } from 'react-icons/hi';
import { MdEmail, MdPhone } from 'react-icons/md';
import logo from '../images/logo1.png';
import Bounce from 'react-reveal/Bounce';
import { FaFacebook, FaYoutube, FaTwitter, FaLinkedin, FaInstagram } from 'react-icons/fa';
import { IoIosArrowDown } from 'react-icons/io';

import { Link } from 'gatsby';
import { links } from '../data/menuLinks';
import { socialLinks } from './../data/Social';

export default function Layout({ children }) {
  const [menuState, setMenuState] = useState(false);

  const toggleMenu = () => {
    setMenuState((prev) => !prev);
  };

  return (
    <div>
      <nav className='navigation'>
        <div className='topBar'>
          <div className='container'>
            <a href='tel:+16692708699' className='topIcon'>
              <MdPhone /> +1 669 270 8699
            </a>
            <a href='mailto:megaroof@solaricglobal.com' className='topIcon'>
              <MdEmail /> megaroof@solaricglobal.com
            </a>
            <a href='tel:+8801750150255' className='topIcon'>
              <MdPhone /> +880 1750 150 255
            </a>
          </div>
        </div>
        <div className='container'>
          <Link to='/'>
            <img src={logo} className='logo' alt='Solaric Logo' />
          </Link>
          <div className='right-menu'>
            <ul className='links'>
              <li>
                {links.map((link) => (
                  <div className='dropdown'>
                    <Link activeClassName='active' className='link dropbtn' to={`${link.url}`}>
                      {link.text} {link.subLinks && <IoIosArrowDown />}
                    </Link>
                    <div className='dropdown-content'>
                      {link.subLinks?.map((link, i) => (
                        <Link to={link.url} key={i}>
                          {link.text}
                        </Link>
                      ))}
                    </div>
                  </div>
                ))}
              </li>
            </ul>
            <div className='menu' onClick={toggleMenu}>
              <div className='menu-icon-container d-flex align-items-center'>
                <span>Menu</span> <HiMenu className='menu-icon' />
              </div>
            </div>
            <Navigation menuState={menuState} toggleMenu={toggleMenu} />
          </div>
        </div>
      </nav>

      <div className='social-links'>
        {socialLinks.map((social) => (
          <a key={social.id} target='_blank' href={social.url} className='social-link' style={{ color: social.color }}>
            {social.icon}
          </a>
        ))}
      </div>

      <div style={{ marginTop: '80px' }}>{children}</div>
      <footer className='footer'>
        <div className='container text-white bottomCTA p-2'>
          <div className='row'>
            <div className='col-md-7 d-flex flex-column justify-content-center p-4'>
              <Bounce left>
                <h2>Have Questions? We are Here to Help You!</h2>
              </Bounce>
            </div>
            <div className='col-md-5 right'>
              <div className='big-text'>24/7</div>
              <Bounce right>
                <div className='btn button'>
                  <Link to='/contact'>Learn More</Link>
                </div>
              </Bounce>
            </div>
          </div>
        </div>
        <div className='container footerContent'>
          <div className='row'>
            <div className='col-md-6 img '>
              <Link to='/'>
                <img src={logo} height='50px' alt='Solaric Logo' />
              </Link>
              <div className='social-links-horizontal'>
                {socialLinks.map((social) => (
                  <a
                    key={social.id}
                    target='_blank'
                    href={social.url}
                    className='social-link'
                    style={{ color: social.color }}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
              <div className='footer-mail-phone'>
                <a href='tel:+16692708699'>
                  <MdPhone /> +1 669 270 8699
                </a>
                <a href='mailto:megaroof@solaricglobal.com'>
                  <MdEmail /> megaroof@solaricglobal.com
                </a>
                <a href='tel:+8801750150255'>
                  <MdPhone /> +880 1750 150 255
                </a>
              </div>
            </div>
            <div className='col-md-6'>
              <form className=''>
                <p className='font-weight-bold'>Get Notified</p>
                <div className='d-flex'>
                  <div className='input-group mr-2'>
                    <span className='input-group-text'>
                      <MdEmail />
                    </span>
                    <input type='text' className='form-control' placeholder='Email Address' />
                    <input type='submit' className='btn btn-success' value='Subscribe' />
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12 col-lg-8 copyright mx-auto text-center'>
              <div className='d-md-flex justify-content-around pb-2'>
                <p> {new Date().getFullYear()} &#169; Copyright Solaric</p>
                <ul className='bottom-links'>
                  {links.map((link) => {
                    return (
                      <Link to={link.url} key={link.id}>
                        {link.text}
                      </Link>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className='credit'>
          Developed by{' '}
          <a href='https://www.facebook.com/retrondigital' className='link' target='_blank'>
            Retron Digital Solutions
          </a>
        </div>
      </footer>
    </div>
  );
}
